import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

// Elenco tipi di campo supportati (usato anche dall'editor Admin)
export const CUSTOM_FIELD_TYPES = [
  { value: "testo", label: "Testo" },
  { value: "numero", label: "Numero" },
  { value: "data", label: "Data" },
  { value: "select", label: "Elenco a scelta" },
  { value: "booleano", label: "Sì / No" },
];

const matchesTarget = (f, target) => {
  const t = f.target || "pratica";
  return t === target || t === "both" || t === "entrambe";
};

// Render dinamico dei campi personalizzati di un servizio, filtrati per target ("pratica" | "persona").
export const CustomFieldsForm = ({ defs = [], values = {}, onChange, target = "pratica", disabled = false }) => {
  const fields = (defs || []).filter((f) => f.chiave && matchesTarget(f, target));
  if (fields.length === 0) return null;
  const set = (k, v) => onChange({ ...(values || {}), [k]: v });

  return (
    <div className="grid sm:grid-cols-2 gap-3" data-testid={`custom-fields-${target}`}>
      {fields.map((f) => {
        const k = f.chiave;
        const val = values ? values[k] : undefined;
        const id = `cf-${target}-${k}`;
        const wide = f.tipo === "select" ? "" : "";
        return (
          <div key={k} className={wide}>
            <Label htmlFor={id}>{f.label || k}</Label>
            {f.tipo === "numero" ? (
              <Input id={id} type="number" disabled={disabled} value={val ?? ""}
                onChange={(e) => set(k, e.target.value === "" ? null : Number(e.target.value))}
                className="h-10" data-testid={id} />
            ) : f.tipo === "data" ? (
              <Input id={id} type="date" disabled={disabled} value={val || ""}
                onChange={(e) => set(k, e.target.value)} className="h-10" data-testid={id} />
            ) : f.tipo === "select" ? (
              <Select value={val || ""} onValueChange={(v) => set(k, v)} disabled={disabled}>
                <SelectTrigger id={id} className="h-10" data-testid={id}><SelectValue placeholder="Seleziona…" /></SelectTrigger>
                <SelectContent className="max-h-64">
                  {(f.opzioni || []).filter(Boolean).map((o) => <SelectItem key={o} value={o}>{o}</SelectItem>)}
                </SelectContent>
              </Select>
            ) : f.tipo === "booleano" ? (
              <div className="flex items-center gap-2 h-10">
                <Switch id={id} checked={!!val} onCheckedChange={(v) => set(k, v)} disabled={disabled} data-testid={id} />
                <span className="text-sm text-muted-foreground">{val ? "Sì" : "No"}</span>
              </div>
            ) : (
              <Input id={id} disabled={disabled} value={val || ""}
                onChange={(e) => set(k, e.target.value)} className="h-10" data-testid={id} />
            )}
          </div>
        );
      })}
    </div>
  );
};

// Restituisce true se ci sono campi definiti per un dato target
export const hasCustomFields = (defs = [], target = "pratica") =>
  (defs || []).some((f) => f.chiave && matchesTarget(f, target));
